import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function BackButton() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useLanguage();

  if (pathname === "/") return null;

  const handleBack = () => {
    const idx = window.history.state?.idx;
    if (typeof idx === "number" && idx > 0) {
      navigate(-1);
      return;
    }
    const parent = pathname.replace(/\/+$/, "").split("/").slice(0, -1).join("/") || "/";
    navigate(parent);
  };

  return (
    <button
      type="button"
      data-testid="global-back-button"
      onClick={handleBack}
      aria-label={t("common.back")}
      className="fixed start-3 top-24 z-40 inline-flex items-center gap-1.5 rounded-full bg-white/75 px-3 py-1.5 text-xs font-semibold text-slate-600 shadow-sm ring-1 ring-slate-200/60 backdrop-blur-md transition-colors hover:text-gold-hover hover:ring-gold/50 sm:start-5 sm:text-[13px]"
    >
      <ArrowLeft className="h-3.5 w-3.5 rtl:-scale-x-100" aria-hidden="true" />
      <span>{t("common.back")}</span>
    </button>
  );
}
